module.exports = __webpack_public_path__ + "img/1-3.5b2c0634.png";